import React, {useState, useEffect, Fragment} from "react";
import {connect} from "react-redux"
import Product from "./Product";
import ProductsServices from "../../../../services/ProductsServices";

import Style from "./Products.scss";

const listContainer = {
    "maxHeight": "900px",
    "overflow": "auto"

}
const Products = (props)=>{

    const [asData, setAsData] = useState(false)
    const [products, setProducts] = useState([])
    const [active, setActive] = useState('dpu')
    const [selected, setSelected] = useState()
    const [listForm, setListForm] = useState()
    let productService = new ProductsServices()

    const [collectivForms, setCollectivForms] = useState(
        productService.getFormsPRoducts('collective')
        /*
        {
        sections: [
            {
                title: "Urbanisme Régelmentaire",
                order: 0,
                forms: [
                    {'label': 'Renseignement d\'Urbanisme ', 'code': 'ru', 'amount': null, "info": "linkInfo", "order": 0, "activ": true, "styles": ""},
                    {'label': 'Certificat d\'Urbanisme ', 'code': 'cua', 'amount': null, "info": "linkInfo", "order": 0, "activ": true, "styles": ""},
                    {'label': 'Certificat d\'Urbanisme ', 'code': 'cub', 'amount': null, "info": "linkInfo", "order": 0, "activ": true, "styles": ""},
                ]
            },
        ]
    }

         */
    )
    const [proForms, setProForms] = useState(
        productService.getFormsPRoducts('pro')
        /*
        {
        sections: [
            {
                title: "Urbanisme Régelmentaire",
                order: 0,
                forms: [
                    {
                        'label': 'Note de renseignement d\'Urbanisme ',
                        'code': 'nru',
                        'amount': 100.0,
                        "info": "linkInfo",
                        "order": 0,
                        "activ": true,
                        "styles": ""
                    },
                    {
                        'label': 'Note de renseignement d\'Urbanisme - professionnels  ',
                        'code': 'nrupro',
                        'amount': 120.0,
                        "info": "linkInfo",
                        "order": 0,
                        "activ": true,
                        "styles": ""
                    },
                    {
                        'label': 'Note de renseignement d\'Urbanisme - Experts ',
                        'code': 'nruexp',
                        'amount': 150.0,
                        "info": "linkInfo",
                        "order": 0,
                        "activ": true,
                        "styles": ""
                    },
                    {
                        'label': 'État des Risques et Pollution',
                        'code': 'erp',
                        'amount': 15.0,
                        "info": "linkInfo",
                        "order": 0,
                        "activ": true,
                        "styles": ""
                    },
                    {
                        'label': 'Droit de préemption',
                        'code': 'dpu',
                        'amount': 30.0,
                        "info": "linkInfo",
                        "order": 0,
                        "activ": true,
                        "styles": ""
                    },
                    {
                        'label': 'Plan d\'aménagement et de développement durable de la Corse ',
                        'code': 'pad',
                        'amount': 35.0,
                        "info": "linkInfo",
                        "order": 0,
                        "activ": true,
                        "styles": ""
                    },
                    {
                        'label': 'Étude d\'urbanisme et de faisabilité ',
                        'code': 'euf',
                        'amount': 26.0,
                        "info": "linkInfo",
                        "order": 0,
                        "activ": true,
                        "styles": ""
                    },
                    {
                        'label': 'Certificat d\'Urbanisme d\'information ',
                        'code': 'cua',
                        'amount': 30,
                        "info": "linkInfo",
                        "order": 0,
                        "activ": true,
                        "styles": ""
                    },
                    {
                        'label': 'Certificat d\'Urbanisme opérationnel',
                        'code': 'cub',
                        'amount': 468,
                        "info": "linkInfo",
                        "order": 0,
                        "activ": true,
                        "styles": ""
                    },

                ]
            },
        ]
    }

         */
    )



    useEffect(()=>{
        setListForm(proForms)
        setActive(proForms.sections[0].code)
        props.selectedProduct(proForms.sections[0])
    }, [])

    useEffect(()=>{
        (props.entity && props.entity?.genre.slug == 'collective')?setListForm(collectivForms):setListForm(proForms);
    }, [ props.entity])

    useEffect(()=>{

    }, [proForms, collectivForms, products, selected, listForm])

    useEffect(()=>{
        setProducts(props.items)
        //console.log(props.items)
    }, [props.items])

    const handleProductSelect = (e)=>{
        setActive(e.code)
        let currentProduct = _.find(products, function(o) { return o.code === e.code; });
        (currentProduct)?setSelected(currentProduct):null;
        props.selectedProduct(e)
    }




    const renderSectionFormsList = (refs,index)=>{
        return (
            <Fragment key={index}>
                {/*<div className={"formList-section-title"} >{refs.title} :</div>*/}
                <div className={""} >
                    {
                        refs.forms.map((item2,index2)=>renderItemsFormList(item2, index2))
                    }
                </div>
            </Fragment>
        )
    }

    const renderItemsFormList = (ref, index)=>{
        return(
            <div key={index} className={"ueBtnOverlay d-flex flex-row justify-content-between align-items-center my-2 border-bottom border-gray-300"} >
                <div className={"d-flex flex-row justify-content-start align-items-center py-2 flex-grow-1 ueProductBtnHover"}
                     onClick={(e)=>handleProductSelect(ref)}
                     style={{"borderRight": (active===ref.code)?"6px solid var(--theme-primary)":null}}
                >
                    <div className={"text-primary font-weight-bold  text-uppercase formList-code"}>{ref.code} </div>
                    <div style={{"lineHeight": "1.1rem"}}>{ref.label}</div>
                </div>
            </div>
        )
    }

    return (
        <div className={"constainer d-flex flex-column flex-md-row h-100"} style={listContainer}>
            <div className="p-3 mr-md-2" style={{"backgroundColor": "var(--theme-page-background)", "color": "var(--theme-color)"}} >
                {
                    (listForm)
                        ? listForm.sections.map((item,index)=>renderSectionFormsList(item,index))
                        : null
                }
            </div>
            <div className="p-3 vh-100" style={{"backgroundColor": "var(--theme-page-background-alternate)", "color": "var(--theme-color) "}} >
            {   (props.items && props.items.length > 0)?
                 (selected)?
                        <Product key={selected.id} item={selected} />
                        :<Product key={0} item={props.items[0]} />
                :null
            }
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
        entity: state.MeReducer.entity,
        subscription: state.MeReducer.subscription,
    }
}


const mapDispatchTProps = dispatch => {
    return {
        updateStructureInfo: (e) => dispatch( {type: 'UPDATE_STRUCTURE_INFO', data:e}),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(Products);





